import { apiRequest } from '@/api/request.js'

const appendQueryParam = (url, key, value) => {
  if (value === undefined || value === null || value === '') {
    return url
  }
  return `${url}${url.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(value)}`
}

const normalizeCollectionUsage = params => {
  const usage = params?.data?.usage
  if (usage === undefined || usage === null || usage === '') {
    return params
  }
  return {
    ...params,
    data: {
      ...params.data,
      usage: Number(usage) === 2 ? 2 : 1
    }
  }
}

export const getProdDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ma/spu/prod_info',
    method: 'GET'
  })
}
export const getScoreProdDetail = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ma/spu/score_prod_info',
    method: 'GET'
  })
}
export const listProdSkuOptions = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ma/spu/sku_list',
    method: 'GET'
  })
}
export const listRecommendedProds = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ma/spu/recommend_list',
    method: 'GET'
  })
}
export const listExpiredCartProds = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/shop_cart/expiry_prod_list',
    method: 'GET'
  })
}
export const listExpiredCartProdsV2 = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/app/v2/shop_cart/expiry_prod_list',
    method: 'GET'
  })
}
export const getCartInfo = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/shop_cart/info',
    method: 'GET'
  })
}
export const getCartInfoV2 = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/app/v2/shop_cart/info',
    method: 'GET'
  })
}
export const getCartInfoByStationId = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/shop_cart/info_by_station_id',
    method: 'GET'
  })
}

export const queryCartCount = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/shop_cart/ma/prod_count',
    method: 'GET'
  })
}
export const listProdBrowseLogs = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/spu_browse_log/page',
    method: 'GET'
  })
}
export const queryProdCollectionCount = (params = {}) => {
  const normalizedParams = normalizeCollectionUsage(params)
  const usage = normalizedParams?.data?.usage
  return apiRequest({
    ...normalizedParams,
    url: appendQueryParam('/mall4cloud_product/spu_collection/count', 'usage', usage),
    method: 'GET'
  })
}
export const listProdCollectionPage = (params = {}) => {
  return apiRequest({
    ...normalizeCollectionUsage(params),
    url: '/mall4cloud_product/spu_collection/page',
    method: 'GET'
  })
}
export const checkProdCollectionStatus = (params = {}) => {
  return apiRequest({
    ...normalizeCollectionUsage(params),
    url: '/mall4cloud_product/spu_collection/ma/is_collection',
    method: 'GET'
  })
}
export const listProdCommentPage = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/spu_comm/ua/page',
    method: 'GET'
  })
}
export const getProdCommentStats = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/spu_comm/ua/prod_comm_data',
    method: 'GET'
  })
}
export const listCategoryList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ua/category/category_list',
    method: 'GET'
  })
}
export const listShopCategoryList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ua/category/shop_category_list',
    method: 'GET'
  })
}
/**
 * 获取当前使用场景下存在 App 可见商品的平台分类树
 */
export const listFilteredProductCategories = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ua/category/filter_product_category',
    method: 'GET'
  })
}
export const listShopCategoryByStationId = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ua/category/shop_category_list_by_station_id',
    method: 'GET'
  })
}
export const listProdTagList = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/ua/spu_tag/list',
    method: 'GET'
  })
}
export const changeCartItem = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/shop_cart/change_item',
    method: 'POST'
  })
}
export const changeCartItemV2 = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/app/v2/shop_cart/change_item',
    method: 'POST'
  })
}
// 将选中的再购商品批量加入 V2 购物车。
export const repurchaseAddItemsV2 = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/app/v2/shop_cart/repurchase_add_items',
    method: 'POST'
  })
}
export const batchCheckCartItems = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/shop_cart/check_items',
    method: 'POST'
  })
}
export const checkCartItemV2 = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/app/v2/shop_cart/check_item',
    method: 'POST'
  })
}
export const addProdBrowseLog = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/spu_browse_log',
    method: 'POST'
  })
}
export const toggleProdCollection = (params = {}) => {
  return apiRequest({
    ...normalizeCollectionUsage(params),
    url: '/mall4cloud_product/spu_collection/add_or_cancel',
    method: 'POST'
  })
}
export const collectAllOrderedProds = (params = {}) => {
  return apiRequest({
    ...normalizeCollectionUsage(params),
    url: '/mall4cloud_product/spu_collection/order_prod_collection_all',
    method: 'POST'
  })
}
export const submitProdComment = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/spu_comm/comments',
    method: 'POST'
  })
}
export const deleteCartItem = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/shop_cart/delete_item',
    method: 'PUT'
  })
}
export const deleteCartItemV2 = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/app/v2/shop_cart/delete_item',
    method: 'PUT'
  })
}
export const clearProdBrowseLog = (params = {}) => {
  return apiRequest({
    ...params,
    url: '/mall4cloud_product/spu_browse_log',
    method: 'PUT'
  })
}
